import { render, staticRenderFns } from "./ChannelManagerNames.vue?vue&type=template&id=40059e4f&"
import script from "./ChannelManagerNames.vue?vue&type=script&lang=js&"
export * from "./ChannelManagerNames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40059e4f')) {
      api.createRecord('40059e4f', component.options)
    } else {
      api.reload('40059e4f', component.options)
    }
    module.hot.accept("./ChannelManagerNames.vue?vue&type=template&id=40059e4f&", function () {
      api.rerender('40059e4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/ChannelManagerNames.vue"
export default component.exports